/**
 * Footer Mimir Trigger Script
 * Handles opening the Mimir modal from footer buttons
 */

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-mimir-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      window.dispatchEvent(new Event('mimir:open'));
    });
  });
});
